import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import CelestialBackground from "@/components/CelestialBackground";
import AppleSignInButton from "@/components/AppleSignInButton";
import SiteMenu from "@/components/SiteMenu";

// First screen of the iPhone app for signed-out users.
export default function NativeWelcome() {
  return (
    <div className="app-shell relative text-starlight" data-testid="native-welcome">
      <CelestialBackground />
      <SiteMenu floating />
      <div className="relative z-10 min-h-[100dvh] flex flex-col px-6 safe-top pb-10">
        <div className="flex-1 flex flex-col items-center justify-center text-center fade-up">
          <img src="/astra-icon-transparent.png" alt="Astra" className="w-48 h-48 mb-3" />
          <h1 className="font-display text-4xl tracking-[0.35em] pl-[0.35em]">ASTRA</h1>
          <p className="text-[11px] uppercase tracking-[0.3em] gold-text mt-3">Written from the stars</p>
          <p className="text-base text-[#A7B0C0] mt-5 max-w-xs">
            A daily horoscope written for your exact birth chart, using where the planets really are today.
          </p>
        </div>

        <div className="space-y-3 fade-up" style={{ animationDelay: "120ms" }}>
          <Link
            to="/join"
            data-testid="btn-native-create"
            className="block text-center w-full bg-[#D4AF37] hover:bg-[#e6c04e] text-[#04060B] font-medium text-lg py-3.5 rounded-full transition-colors"
          >
            Create free account
          </Link>
          <AppleSignInButton />
          <Link
            to="/join?mode=login"
            data-testid="btn-native-signin"
            className="block text-center w-full border border-[#D4AF37]/40 gold-text text-lg py-3 rounded-full hover:border-[#D4AF37] transition-colors"
          >
            Sign in with email
          </Link>
          <Link
            to="/horoscopes"
            data-testid="link-native-browse"
            className="flex items-center justify-center gap-1 pt-3 text-sm text-[#A7B0C0] hover:text-starlight"
          >
            Browse today's horoscopes without an account <ChevronRight size={14} />
          </Link>
        </div>
      </div>
    </div>
  );
}
